var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-card-text',{staticStyle:{"padding":"0px"}},[_c('MutationForm',{attrs:{"no-reset":"","mutation":"createLink","constants":{ environmentId: _vm.environmentId },"submitButtonText":_vm.$t('links_create.submitButtonText'),"submitButtonIcon":"add","submitButtonColor":_vm.accentColor,"environmentVariables":{ environmentId: _vm.environmentId },"schema":{
        environmentId: {
          __graphQLType: 'ID'
        },
        title: {
          label: _vm.$t('links_create.schema.title.label'),
          type: 'string',
          description: _vm.$t('links_create.schema.title.description'),
          newDesign: true
        }
      }},on:{"success":function($event){return _vm.$emit('create', $event)},"error":function($event){return _vm.$emit('error', $event)}}},[_c('v-btn',{staticStyle:{"border":"2px solid var(--v-primary-base)"},attrs:{"slot":"left-buttons","outlined":""},on:{"click":function($event){return _vm.$emit('dismiss')}},slot:"left-buttons"},[_vm._v(_vm._s(_vm.$t('links_create.cancelBtn')))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }